import { render, staticRenderFns } from "./ModalViewPDF.vue?vue&type=template&id=b6ab5a44&scoped=true"
import script from "./ModalViewPDF.vue?vue&type=script&lang=js"
export * from "./ModalViewPDF.vue?vue&type=script&lang=js"
import style0 from "./ModalViewPDF.vue?vue&type=style&index=0&id=b6ab5a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab5a44",
  null
  
)

export default component.exports